import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { arrayColor, TOOL_TEMPLATE } from "../../constant/common";
import { useTemplateSetting } from "../../hooks/useCompanySettings";
import { colorBlindModeSelector, instrumentsSettingsSelector, peersSettingsSelector } from "../../store/slice/settings/selectors";
import { getTickerPatternById } from "../../store/utils";
import { getSvgOfDashStyle } from "@euroland/react-high-chart";

function TickerLengendMultipleLineChart({datas = []}) {
  const colorBlindMore = useSelector(colorBlindModeSelector);
  const instrumentSetting = useSelector(instrumentsSettingsSelector);
  const peerSetting = useSelector(peersSettingsSelector);
  const tickers = useMemo(() => [...instrumentSetting, ...peerSetting], [instrumentSetting, peerSetting]);
  const template = useTemplateSetting();

  const isVictor = template === TOOL_TEMPLATE.victor;
  if(!colorBlindMore) return null;
  if (datas.length === 0) return null;

  return (
    <ul className="legend-chart">
      {datas.map((item, index) => {
        const itemInstrument = tickers.find(x => Number(x.id) === Number(item.instrumentId));
        return (
          <li className="legend-chart__item" key={item.instrumentId}>
            {getSvgOfDashStyle({
              color: itemInstrument?.color || arrayColor[index],
              lineWidth: 3,
              dashStyle: getTickerPatternById(item.instrumentId),
              isReactComponent: true,
            })}
            <p className="legend-chart__text">{isVictor ? `${item.ticker} (${item.marketAbbreviation})` : item.shareName}</p>
          </li>
        )
      })}
    </ul>
  );
}

export default TickerLengendMultipleLineChart;
